// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"787d7824","952":"62ec8d37"}[chunkId] + ".chunk.js";
};